var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list-item',{class:[_vm.align]},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"font-weight-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('v-list-item-subtitle',{staticClass:"font-weight-regular"},[_vm._v(" "+_vm._s(_vm.caption)+" ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }